import React from 'react';
import { 
  Header, 
  HeroPainHook, 
  ZigzagFeatures, 
  DailyUseSection, 
  PricingDetails, 
  FinalCTA,
  Footer 
} from '../components/landing';

const LandingPage = () => {
  return (
    <div className="bg-white selection:bg-[#0DA2E7] selection:text-white overflow-x-clip">
      <Header />
      <main>
        <HeroPainHook />
        <ZigzagFeatures />
        <DailyUseSection />
        <PricingDetails />
        <FinalCTA />
        <Footer />
      </main>
    </div>
  );
};

export default LandingPage;
